var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-loader',{staticClass:"pt-0",attrs:{"height":22,"width":400,"speed":5,"primaryColor":"#424242","secondaryColor":"#ecebeb"}},[_c('rect',{attrs:{"x":"4","y":"7","rx":"0","ry":"0","width":"112.42","height":"4"}}),_vm._v(" "),_c('rect',{attrs:{"x":"4","y":"14","rx":"0","ry":"0","width":"304","height":"4"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c97a9daa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/SharedContentLoader.vue
// module id = null
// module chunks = 